import { nameActionPageMain } from '../../info'
import { TypeBreadcrumb } from '../index'

export const breadcrumbList: TypeBreadcrumb[] = [
  {
    name: 'Início',
    to: '/'
  },
  {
    name: 'Configurações'
  },
  {
    name: nameActionPageMain.name
  }
]
